import React from "react";

const AddButton = ({
  style = {},
  width = "29",
  className = "",
  height = "29",
  color = "white",
  backgroundColor = "#027CC1",
  ...rest
}) => (
  <svg
    height={height}
    width={width}
    className={className}
    style={style}
    {...rest}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M14.5 3C20.299 3 25 7.701 25 13.5S20.299 24 14.5 24 4 19.299 4 13.5 8.701 3 14.5 3z"
        fill={backgroundColor}
        fillRule="nonzero"
      />
      <path
        d="M14.5 10v7M18 13.5h-7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default AddButton;
